/* 뷰어 */

import {
  getVacationMap,
  getOtWorkMap,
  getScheduleMap,
  getRewardMap,
  getAttendMap,
  getCancelVacationMap,
  getCancelRewardMap,
} from '@/api/application';

const viewer = {
  state: {
    appMapData: {},
  },
  getters: {
    GET_APPL_MAP_PARAM(state, getters) {
      const appMapData = state.appMapData;
      return {
        ...appMapData,
        ...getters.GET_ELA_APPL_PARAM,
      };
    },
    GET_APP_MAP_DATA(state) {
      return state.appMapData;
    },

    GET_MAP_REASON(state) {
      return state.appMapData.reason || '-';
    },
  },
  mutations: {
    SET_APP_MAP_DATA(state, data) {
      state.appMapData = data;
    },
  },
  actions: {
    /**
     * 근태 - 상세 데이터 조회
     */
    async FETCH_VACATION_MAP({ commit }, param) {
      const response = await getVacationMap(param);
      commit('SET_APP_MAP_DATA', response.data.data);
    },
    /**
     * 연장근무 - 상세 데이터 조회
     */
    async FETCH_OT_WORK_MAP({ commit }, param) {
      const response = await getOtWorkMap(param);
      commit('SET_APP_MAP_DATA', response.data.data);
    },

    /**
     * 근무스케줄 - 상세 데이터 조회
     */
    async FETCH_SCHEDULE_MAP({ commit }, param) {
      const response = await getScheduleMap(param);
      commit('SET_APP_MAP_DATA', response.data.data);
    },

    /**
     * 보상휴가 - 상세 데이터 조회
     */
    async FETCH_REWARD_MAP({ commit }, param) {
      const response = await getRewardMap(param);
      commit('SET_APP_MAP_DATA', response.data.data);
    },

    /**
     * 출퇴근변경신청 - 상세 데이터 조회
     */
    async FETCH_ATTEND_MAP({ commit }, param) {
      const response = await getAttendMap(param);
      commit('SET_APP_MAP_DATA', response.data.data);
    },

    /**
     * 근태취소신청 - 상세 데이터 조회
     */
    async FETCH_CANCEL_VACATION_MAP({ commit }, param) {
      const response = await getCancelVacationMap(param);
      commit('SET_APP_MAP_DATA', response.data.data);
    },

    /**
     * 보상취소신청 - 상세 데이터 조회
     */
    async FETCH_CANCEL_REWARD_MAP({ commit }, param) {
      const response = await getCancelRewardMap(param);
      commit('SET_APP_MAP_DATA', response.data.data);
    },
  },
};

export default viewer;
